import * as Type from './actionsTypes';
import { compareNotasByColumns } from '../../utils/notaSort';

const INITIAL_STATE = {
  notas: [],
  selectedNota: null,
};

const sortNotas = list => [...list].sort(compareNotasByColumns);

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.FETCH_NOTAS_SUCCESS: {
      return {
        ...state,
        notas: sortNotas(Array.isArray(action.data) ? action.data : [])
      }
    }
    case Type.DELETE_NOTA_SUCCESS: {
      return {
        ...state,
        notas: sortNotas(state.notas.filter(s => s.id !== action.data))
      }
    }
    case Type.SAVE_NOTA_SUCCESS: {
      return {
        ...state,
        notas: sortNotas([...state.notas, action.data])
      }
    }
    case Type.UPDATE_NOTA_SUCCESS: {
      return {
        ...state,
        notas: sortNotas([...state.notas.filter(s => s.id !== action.data.id), action.data])
      }
    }
    case Type.NOTA_VALIDATE_BY_ID_SUCCESS: {
      const nota = state.notas.filter(s => s.id === action.id)[0];
      nota.validate = action.validate;
      return {
        ...state,
        notas: sortNotas([...state.notas.filter(s => s.id !== action.id), nota])
      }
    }
    case Type.NOTA_FIND_BY_ID_SUCCESS: {
      return {
        ...state,
        selectedNota: action.data
      }
    }
    case Type.CLEAR_NOTA: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getNotas = state => state.rootState.nota.notas;
export const getSelectedNota = state => state.rootState.nota.selectedNota;
